import React from 'react'

import '../../styles/Footer.css'
const FOOTER_NAV = [
  { label: 'About Us', href: '/about/' },
  { label: 'Advertisement', href: '/advertisement/' },
  { label: 'Career', href: '/career/' },
  { label: 'Contact', href: '/contact/' },
  { label: 'Partner With Us', href: '/partner-with-us/' },
]

const FOOTER_SECTIONS = [
  {
    title: 'Courses',
    links: [
      ['Engineering Course','/course/engineering/'],['Agriculture Course','/course/agriculture/'],['Arts & Science Course','/course/arts-science/'],['Diploma / Polytechnic Course','/course/diploma/'],['Architecture & Design Course','/course/architecture-design/'],['Fishery Science Course','/course/fishery-science/'],['Management & MBA Course','/course/management-mba/'],['MBBS Medical Course','/course/mbbs/'],['BDS Course','/course/bds/'],['Allied Health Science Course','/course/allied-health-science/'],['Veterinary Science Course','/course/veterinary-science/'],['Pharmacy Course','/course/pharmacy/'],['Nursing Course','/course/nursing/'],['Physiotherapy Course','/course/physiotherapy/'],['Occupational Therapy Course','/course/occupational-therapy/'],['Ayurveda Course','/course/ayurveda/'],['Homeopathy Course','/course/homeopathy/'],['Unani Medicine Course','/course/unani/'],['Marine & Nautical Course','/course/marine-nautical/'],['Teacher Education Course','/course/teacher-education/'],['Hotel Management Course','/course/hotel-management/'],['Law (LLB, BA-LLB) Course','/course/law/'],['Psychology Course','/course/psychology/'],['Aviation Course','/course/aviation/'],['Media, Journalism & Visual Communication','/course/media-journalism-visual-communication/'],['Sports & Physical Education Course','/course/sports-physical-education/'],['Fine Arts & Performing Arts Course','/course/fine-arts-performing-arts/'],['Commerce, Finance & Accounting','/course/commerce-finance-accounting/']
    ].map(([label,href])=>({label,href}))
  },
  {
    title: 'Entrance Exams',
    links: [
      ['IMU CET','/entrance-exam/imu-cet/'],['JEE Main','/entrance-exam/jee-main-entrance-examination/'],['JEE Advanced','/entrance-exam/jee-advanced-entrance-examination/'],['MAT','/entrance-exam/mat-entrance-examination/'],['NATA','/entrance-exam/nata-entrance-examination/'],['NIFT','/entrance-exam/nift-entrance-examination/'],['TANCET','/entrance-exam/tancet-management-computer-application-entrance-exam/'],['NEET - UG','/entrance-exam/neet-entrance-examination-ug/'],['NEET - PG','/entrance-exam/neet-pg-entrance-examination/'],['AIIMS & JIPMER','/entrance-exam/aiims-jipmer-via-neet/'],['GATE','/entrance-exam/gate-entrance-examination/'],['CAT','/entrance-exam/cat-entrance-examination/'],['AME CET','/entrance-exam/ame-cet/'],['CMAT','/entrance-exam/cmat-entrance-examination/'],['CEED','/entrance-exam/ceed-entrance-examination/'],['UCEED','/entrance-exam/uceed-entrance-examination/'],['CLAT','/entrance-exam/clat-entrance-examination/'],['LSAT','/entrance-exam/lsat-entrance-examination-lsat-india/'],['CUET','/entrance-exam/cuet-entrance-examination-ug/']
    ].map(([label,href])=>({label,href}))
  },
  {
    title: 'Counselling',
    links: [
      ['Law Counselling','/counselling/law-counselling/'],['Agriculture Counselling','/counselling/agriculture-counselling/'],['Paramedical Counselling','/counselling/paramedical-counselling/'],['Arts & Science Counselling','/counselling/arts-and-science-counselling/'],['Diploma / Polytechnic Counselling','/counselling/diploma-polytechnic-counselling/'],['MBA & MCA Counselling (TANCET)','/counselling/mba-mca-counselling-tancet/'],['Engineering Counselling (TNEA)','/counselling/engineering-counselling-tnea/'],['Medical Counselling (MBBS / BDS & More)','/counselling/medical-counselling-mbbs-bds-more/'],['Teacher Education Counselling','/counselling/teacher-education-counselling/']
    ].map(([label,href])=>({label,href}))
  },
  {
    title: 'Scholarships',
    links: [
      ['7.5 Reservation Scheme','/scholarship/7-5-reservation-scheme/'],['First Graduate Scholarship','/scholarship/first-graduate-scholarship/'],['BC / MBC / DNC Scholarship','/scholarship/bc-mbc-dnc-scholarship/'],['Post-Matric Scholarship','/scholarship/post-matric-scholarship/'],["Chief Minister's Merit Award",'/scholarship/chief-ministers-merit-award/'],['Pudhumai Penn Scheme','/scholarship/pudhumai-penn-scheme/'],['Differently-Abled Scholarship','/scholarship/differently-abled-scholarship/'],['Tamizh Pudhalvan Scheme','/scholarship/tamizh-pudhalvan-scheme/'],['Central Sector Scholarship Scheme','/scholarship/central-sector-scholarship-scheme/'],['Single Parent/Orphan Scholarship','/scholarship/single-parent-or-orphan-scholarship/'],['National Means-cum-Merit Scholarship','/scholarship/national-means-cum-merit-scholarship/'],['AICTE Pragati & Saksham Scholarship','/scholarship/aicte-pragati-saksham-scholarship/'],['Adi Dravidar & Tribal Welfare Scholarship','/scholarship/adi-dravidar-tribal-welfare-scholarship/'],['Minority Scholarship (Muslim / Christian)','/scholarship/minority-scholarship-muslim-christian/'],['Nalavariyam Scholarship Scheme','/scholarship/nalavariyam-scholarship-scheme/'],['Sports Scholarship','/scholarship/sports-scholarship/'],['Perasiriyar Anbazhagan Teacher Education Scholarship','/scholarship/perasiriyar-anbazhagan-teacher-education-scholarship/']
    ].map(([label,href])=>({label,href}))
  },
  {
    title: 'Our Services',
    links: [
      ['Direct College Admissions','/services/direct-college-admission-india/'],['Online UG / PG Admissions','/services/online-ug-pg-admissions/'],['Distance Education Admissions','/services/distance-education-admissions/'],['Abroad Admissions','/services/abroad-admission/']
    ].map(([label,href])=>({label,href}))
  },
  {
    title: 'Colleges',
    links: [
      ['Engineering Colleges','/colleges/engineering/'],['Agriculture Colleges','/colleges/agriculture/'],['Arts & Science Colleges','/colleges/arts-science/'],['Diploma Colleges','/colleges/diploma/'],['MBA Colleges','/colleges/management-mba/'],['Pharmacy Colleges','/colleges/pharmacy/'],['Nursing Colleges','/colleges/nursing/'],['Physiotherapy Colleges','/colleges/physiotherapy/'],['Allied Health Science Colleges','/colleges/allied-health-science/'],['Teacher Education Colleges','/colleges/teacher-education/'],['Hotel Management Colleges','/colleges/hotel-management/'],['Ayurveda Colleges','/colleges/ayurveda/'],['Law Colleges','/colleges/law/'],['BDS Colleges','/colleges/bds/'],['Veterinary Science Colleges','/colleges/veterinary/'],['Physical Education Colleges','/colleges/sports/'],['MBBS Colleges','/colleges/mbbs/'],['Fishery Science Colleges','/colleges/fishery/'],['Marine & Nautical Colleges','/colleges/marine/'],['Homeopathy Colleges','/colleges/homeopathy/'],['Architecture & Design Colleges','/colleges/architecture-design/'],['Occupational Therapy Colleges','/colleges/occupational-therapy/'],['Unani Medicine Colleges','/colleges/unani/'],['Psychology Colleges','/colleges/psychology/'],['Media, Journalism & Visual Communication Colleges','/colleges/media-journalism-visual-communication/'],['Fine Arts & Performing Arts Colleges','/colleges/fine-arts-performing-arts/'],['Aviation Colleges','/colleges/aviation/'],['Commerce, Finance & Accounting Colleges','/colleges/commerce-finance-accounting/']
    ].map(([label,href])=>({label,href}))
  },
  {
    title: 'Our Tools',
    links: [
      ['Career Path Generator','/tools/career-path-generator/'],['Scholarship Finder','/tools/scholarship-finder-tool/'],['Cutoff Calculator','/tools/cut-off-calculator-tool/'],['Skill Recommendation','/tools/skill-recommentation-tool/'],['Blog','/blog/'],['Admission Helpline','/tools/admission-helpline/']
    ].map(([label,href])=>({label,href}))
  },
]


export default function Footer() {
  return (
    <footer className="mega-footer">
      
      <div className="mega-container">

        {/* TOP SECTION */}
        <div className="mega-top">
          <div className="mega-logo">
            <img src="/assets/footer-logo-collegeshine.webp" width={240} height={87} loading="lazy" decoding="async" alt="CollegeShine logo" style={{ display: 'block', width: 'min(240px, 100%)', height: 'auto', objectFit: 'contain' }} />
          </div>

          <nav className="mega-nav" aria-label="Footer navigation">
            {FOOTER_NAV.map((item) => (
              <a key={item.label} href={item.href}>
                {item.label}
              </a>
            ))}
          </nav>

          <div className="mega-social">
            <a href="https://instagram.com/collegeshine">
              <img src="/assets/instagram.svg" alt="Instagram" />
            </a>
            <a href="https://facebook.com/collegeshine">
              <img
                style={{ borderRadius: '50%' }}
                src="/assets/facebook.svg"
                alt="Facebook"
              />
            </a>
            <a href="https://www.youtube.com/@collegeshine">
              <img src="/assets/youtube.svg" alt="YouTube" />
            </a>
          </div>
        </div>

        {/* LINK SECTIONS: Courses, Entrance Exams, Counselling, Scholarships, Our Services, Colleges, Our Tools */}
        {FOOTER_SECTIONS.map((section) => (
          <div className="mega-row" key={section.title}>
            <div className="mega-title">{section.title}</div>
            <div className="mega-links">
              {section.links.map((link) => (
                <a key={link.label} href={link.href}>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        ))}

        {/* CONTACT SECTION */}
        <section className="footer-contact-section" style={{ marginTop: 0 }}>
          <div className="footer-contact-container">

            <div className="footer-contact-left">
              <h3 className="footer-title">Contact Us</h3>

              <a
                href="https://wa.me/919543854321"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-item"
              >
                <div className="icon-circle">
                  <img
                    src="/assets/whatsapp.svg"
                    width="35"
                    height="35"
                    decoding="async"
                    alt="WhatsApp"
                  />
                </div>
                <div className="contact-text">
                  <span className="label">WhatsApp</span>
                  <span className="value">+91 95438 54321</span>
                </div>
              </a>

              <a href="tel:+919865553629" className="contact-item">
                <div className="icon-circle">
                  <img
                    src="/assets/phone.svg"
                    width="35"
                    height="35"
                    decoding="async"
                    style={{ fill: 'white' }}
                    alt="Call"
                  />
                </div>
                <div className="contact-text">
                  <span className="label">Helpline</span>
                  <span className="value">+91 98655 53629</span>
                </div>
              </a>

              <a href="mailto:info@collegeshine.com" className="contact-item">
                <div className="icon-circle">
                  <img
                    src="/assets/mail.svg"
                    width="35"
                    height="35"
                    decoding="async"
                    alt="Email"
                  />
                </div>
                <div className="contact-text">
                  <span className="label">Email</span>
                  <span className="value">info@collegeshine.com</span>
                </div>
              </a>
            </div>

            <div className="footer-contact-right">
              <h3 className="footer-title">Our Office</h3>
              <div className="contact-item office-item">
                <div className="icon-location" style={{ height: 30, marginTop: 8, fontSize: 28 }}>
                  <img
                    src="/assets/location.svg"
                    width="24"
                    height="24"
                    decoding="async"
                    style={{ width: 24, height: 24, borderRadius: '40%' }}
                    alt="CollegeShine office location"
                  />
                </div>
                <div className="contact-text">
                  <strong style={{ fontSize: 25 }}>CollegeShine</strong>
                  <p style={{ fontSize: 19, color: 'white' }}>
                    Registered Office: 1st Floor , Aandavar & Co Building ,<br />
                    RAS & Lakshmi Theatre, Backside, Salem Main Road,<br />
                    Komarapalayam(PO), Namakkal(DT) , Tamil Nadu 638183
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* BOTTOM BAR */}
        <div className="mega-bottom" style={{ marginTop: 0 }}>
          <div className="mega-bottom-inner">
            <div>
              Copyright © 2026 <a href="/">CollegeShine.com</a> All Rights Reserved.
            </div>
            <a href="/sitemap.xml">Site Map</a>
            <a href="/privacy-policy/">Privacy Policy</a>
            <a href="/terms-and-conditions/">Terms & Condition</a>
          </div>
        </div>

      </div>
    </footer>
  )
}
